import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  StringCustomFieldConfig,
  SharedModule,
  FormInputComponent,
  DataService,
  NotificationService
} from '@vendure/admin-ui/core';
import { LabeledImageData } from '../common/ui-types';
import { safeJSONParse } from '../../common/ui/utils';
import { Asset } from '../../common/ui/generated';

@Component({
  template: `
    <vdr-form-field class="border-form">
      <div class="form-row">
        <vdr-form-field [label]="'Label'" class="form-item">
          <input type="text" [formControl]="labelControl" />
        </vdr-form-field>
        <vdr-form-field [label]="'Image'" class="form-item">
          <vdr-relation-asset-input
            [parentFormControl]="imageControl"
            [config]="config"
            [readonly]="readonly"
          ></vdr-relation-asset-input>
        </vdr-form-field>
      </div>
    </vdr-form-field>
  `,
  standalone: true,
  styleUrls: ['../../common/ui/styles.scss'],
  imports: [SharedModule],
})
export class LabeledImageFormComponent
  implements FormInputComponent<StringCustomFieldConfig>, OnInit, AfterViewInit
{
  readonly: boolean;
  config: StringCustomFieldConfig;
  formControl: FormControl;

  labeledImageData: LabeledImageData;
  imageControl = new FormControl();
  labelControl = new FormControl();

  constructor(
    private dataService: DataService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    const defaultLabeledImageData: LabeledImageData = {
        label: '',
        assetId: null,
    };
    this.labeledImageData = safeJSONParse<LabeledImageData>(
      this.formControl.value,
      this.notificationService,
      defaultLabeledImageData,
    )!;
    this.initializeFormControls();
    // Load the Asset based on the stored ID
    if (this.labeledImageData?.assetId) {
      this.dataService.product
        .getAsset(this.labeledImageData.assetId.toString())
        .mapSingle((data) => data.asset)
        .subscribe((asset) => {
          this.imageControl.setValue(asset);
        });
    }
  }

  ngAfterViewInit() {
    this.imageControl.valueChanges.subscribe(this.onImageChange);
    this.labelControl.valueChanges.subscribe(this.onLabelChange);
  }

  private initializeFormControls() {
    this.labelControl.setValue(this.labeledImageData?.label);
  }

  private onImageChange = (value: Asset | null) => {
    const iconId = value ? value.id : null;
    if (this.labeledImageData?.assetId !== iconId) {
      this.labeledImageData!.assetId = iconId;
      this.updateFormControlValue();
    }
  };

  private onLabelChange = (value: string) => {
    if (this.labeledImageData?.label !== value) {
      this.labeledImageData!.label = value;
      this.updateFormControlValue();
    }
  };

  private updateFormControlValue() {
    this.formControl.setValue(JSON.stringify(this.labeledImageData));
    this.formControl.markAsDirty();
  }
}
